/**
 * Maps a pathname to top-bar breadcrumb segments.
 * `muted: true` renders as the lighter trailing segment.
 *
 * @param {string} pathname
 * @param {string} courseTitle Current course name, from sessionStorage/graspd:setCourseTitle.
 * @returns {Array<{ text: string, muted: boolean }>}
 */
export function buildBreadcrumb(pathname, courseTitle) {
  const path = pathname || '';

  if (path.startsWith('/courses/')) {
    return [
      { text: 'Courses', muted: false },
      { text: courseTitle || 'Course', muted: true },
    ];
  }
  if (path === '/dashboard') {
    return [
      { text: 'Courses', muted: false },
      { text: 'All', muted: true },
    ];
  }
  if (path === '/insights/portfolio') {
    return [
      { text: 'Analytics', muted: false },
      { text: 'Transcript', muted: true },
    ];
  }
  if (path.startsWith('/insights')) return [{ text: 'Analytics', muted: false }];
  if (path.startsWith('/g-score')) return [{ text: 'G-Score', muted: false }];
  if (path.startsWith('/family')) return [{ text: 'Parents', muted: false }];
  if (path === '/course/new' || path === '/request') return [{ text: 'Create course', muted: false }];
  if (path.startsWith('/settings')) return [{ text: 'Settings', muted: false }];
  // Task 5 moved /help into the shell (it used to be a standalone
  // chrome-hidden page) — it's now a normal sidebar destination, so it
  // gets a top-level crumb like the other UTILITY_ITEMS/NAV_ITEMS routes.
  if (path.startsWith('/help')) return [{ text: 'Help', muted: false }];

  return [];
}
